import React from "react";
import PropTypes from "prop-types";
import { Button } from "@blueprintjs/core";
//import { Button } from '@material-ui/core';
import "./WebNetButton.css";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";

const WebNetButton = ({ path, text, icon, onClick, match, neverActive, rightIcon}) => {
  let active = path === match.path;
  if (typeof neverActive !== "undefined" && neverActive) {
    active = false;
  }
  return <Link to={path}>
    <Button
      className="imager-button"
      active={active}
      large
      intent="primary"
      text={text}
      icon={icon}
      path={path}
      rightIcon={rightIcon}
      onClick={onClick} />
  </Link>;
};

WebNetButton.propTypes = {
  path: PropTypes.string.isRequired,
  text: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  match: PropTypes.object.isRequired,
  neverActive: PropTypes.bool
};

export default withRouter(WebNetButton);
